import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { gameDetails } from "../../services/game.services";
import { formateDateWithMonth } from "../../../../utils/commonfunction";

const GameView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Games"), url: "/admin/game-management/game/list/1" },
    { title: t("View"), url: "" },
  ];

  useEffect(() => {
    gameDetails(id)
      .then((response) => {
        if (response.success) {
          setData(response.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <Loader />;

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">{t("Game Details")}</h6>
              <button
                className="btn ripple btn-main-primary signbtn"
                onClick={() => navigate(-1)}
              >
                {t("btn_back")}
              </button>
            </div>
            {data ? (
              <div className="row">
                <div className="col-md-4">
                  <div className="mb-3">
                    <strong>{t("Thumbnail")}:</strong>
                    <div className="mt-2">
                      <img
                        src={data.thumbnail || "N/A"}
                        alt="thumbnail"
                        style={{
                          width: "100%",
                          maxWidth: "300px",
                          borderRadius: "8px",
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <strong>{t("Title")}:</strong>
                      <p>{data.title || "N/A"}</p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>{t("Category")}:</strong>
                      <p>{data.category || "N/A"}</p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>{t("Total Levels")}:</strong>
                      <p>{data.total_levels || 0}</p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>{t("Difficulty")}:</strong>
                      <p>{data.difficulty_level || "Easy"}</p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>{t("Status")}:</strong>
                      <p>
                        {data.is_active ? t("btn_active") : t("btn_inactive")}
                      </p>
                    </div>
                    <div className="col-md-6 mb-3">
                      <strong>{t("Created At")}:</strong>
                      <p>
                        {data.createdAt
                          ? formateDateWithMonth(data.createdAt)
                          : "N/A"}
                      </p>
                    </div>
                    <div className="col-md-12 mb-3">
                      <strong>{t("Description")}:</strong>
                      <p>{data.description || "N/A"}</p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center">{t("msg_no_records")}</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default GameView;
